<template>
  <div class="home-dashboard">
    <section class="home-hero" aria-label="常用创作入口">
      <button class="hero-card hero-primary" type="button" @click="go('create')">
        <transition name="hero-fade">
          <img :key="primaryHeroImage" :src="primaryHeroImage" alt="室内设计效果图" />
        </transition>
        <span class="hero-shade"></span>
        <span class="hero-content"><small>YUNTU AI · 智能空间设计</small><strong>一张平面图<br />快速生成效果图</strong><span class="hero-action">开始创作 <i class="el-icon-right"></i></span></span>
      </button>
      <button class="hero-card hero-secondary" type="button" @click="go('styleReplace')">
        <transition name="hero-fade">
          <img :key="secondaryHeroImage" :src="secondaryHeroImage" alt="不同风格的室内设计效果图" />
        </transition>
        <span class="hero-shade"></span>
        <span class="hero-content"><small>AI 风格实验室</small><strong>换一种风格<br />看看家的更多可能</strong><span class="hero-action light">立即体验 <i class="el-icon-right"></i></span></span>
      </button>
    </section>
    <section class="tool-section">
      <header class="section-title"><div><span>AI TOOLBOX</span><h2>局部调整</h2></div><p>从材质、家具到光线，精细调整空间里的每一处细节</p></header>
      <div class="feature-grid">
        <button v-for="tool in featuredTools" :key="tool.route" type="button" class="feature-card" @click="go(tool.route)">
          <span class="feature-copy"><span class="tool-icon"><i :class="tool.icon"></i></span><strong>{{ tool.title }}</strong><small>{{ tool.description }}</small><span class="card-link">打开工具 <i class="el-icon-right"></i></span></span>
          <img :src="tool.image" :alt="`${tool.title}示例`" loading="lazy" />
        </button>
      </div>
    </section>
    <section class="tool-section compact-section">
      <header class="section-title"><div><span>MORE TOOLS</span><h2>更多设计工具</h2></div></header>
      <div class="compact-grid">
        <button v-for="tool in compactTools" :key="tool.route" type="button" class="compact-card" @click="go(tool.route)">
          <span class="tool-icon"><i :class="tool.icon"></i></span><span><strong>{{ tool.title }}</strong><small>{{ tool.description }}</small></span><i class="el-icon-right compact-arrow"></i>
        </button>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: 'HomeDashboard',
  data() {
    return {
      heroImageIndex: 0,
      heroTimer: null,
      heroImages: [
        '/cases/source-open-living.jpg',
        '/cases/source-modern-dining.jpg',
        '/cases/source-luxury-living.jpg',
        '/cases/source-warm-minimal.jpg',
        '/cases/source-bright-home.jpg',
        '/cases/source-calm-living.jpg'
      ],
      featuredTools: [
        { route: 'styleReplace', title: '风格替换', description: '保留空间结构，一键切换整体设计风格', icon: 'el-icon-brush', image: '/cases/cream-style.png' },
        { route: 'selectionReplacement', title: '框选替换', description: '框选需要修改的区域，按要求精准替换内容', icon: 'el-icon-crop', image: '/cases/source-modern-dining.jpg' },
        { route: 'smartErase', title: '智能消除', description: '涂抹选中区域，自然移除画面元素', icon: 'el-icon-delete', image: '/cases/source-natural-room.jpg' },
        { route: 'lightingConversion', title: '灯光转换', description: '重塑空间光影与氛围，效果现场看', icon: 'el-icon-sunny', image: '/cases/source-luxury-living.jpg' },
        { route: 'highResolution', title: '高清放大', description: '提升效果图清晰度，放大材质与空间细节', icon: 'el-icon-zoom-in', image: '/cases/source-bright-home.jpg' },
      ],
      compactTools: [
        { route: 'lineDraftPlan', title: '线稿出方案', description: '上传手绘线稿，生成产品效果方案', icon: 'el-icon-edit-outline' },
        { route: 'softDecorationExtract', title: '软装方案提取', description: '提取风格、配色与关键单品', icon: 'el-icon-collection' },
        { route: 'furnitureCutoutRender', title: '家具白底渲染', description: '生成干净专业的商品展示图', icon: 'el-icon-picture-outline' },
        { route: 'furnitureSceneGeneration', title: '家具场景生成', description: '让单品自然融入真实空间', icon: 'el-icon-camera' },
        { route: 'projects', title: '客户项目管理', description: '集中管理客户与设计任务', icon: 'el-icon-folder-opened' },
        { route: 'cases', title: '案例参考库', description: '浏览精选空间风格案例', icon: 'el-icon-files' }
      ]
    }
  },
  computed: {
    primaryHeroImage() {
      return this.heroImages[this.heroImageIndex % this.heroImages.length]
    },
    secondaryHeroImage() {
      return this.heroImages[(this.heroImageIndex + 2) % this.heroImages.length]
    }
  },
  mounted() {
    this.heroImages.forEach(src => {
      const image = new Image()
      image.src = src
    })
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.heroTimer = window.setInterval(() => {
        this.heroImageIndex = (this.heroImageIndex + 1) % this.heroImages.length
      }, 10000)
    }
  },
  beforeDestroy() {
    if (this.heroTimer) window.clearInterval(this.heroTimer)
  },
  methods: { go(name) { this.$router.push({ name }) } }
}
</script>
<style scoped>
.home-dashboard{width:calc(100% - 28px);margin:0 auto;padding:24px 0 64px}.home-hero{display:grid;grid-template-columns:minmax(0,1.08fr) minmax(0,1.42fr);gap:14px}.hero-card{min-width:0;height:clamp(300px,31vw,430px);overflow:hidden;position:relative;border:0;border-radius:10px;padding:0;background:#18201c;color:#fff;text-align:left;box-shadow:0 12px 34px rgba(25,36,30,.08)}.hero-card>img{width:100%;height:100%;display:block;object-fit:cover;transition:transform .5s cubic-bezier(.2,.8,.2,1)}.hero-card:hover>img{transform:scale(1.035)}.hero-fade-enter-active,.hero-fade-leave-active{transition:opacity .35s ease}.hero-fade-enter,.hero-fade-leave-to{opacity:0}.hero-shade{position:absolute;inset:0;background:linear-gradient(90deg,rgba(10,17,13,.82),rgba(10,17,13,.42) 50%,rgba(10,17,13,.05))}.hero-primary .hero-shade{background:linear-gradient(105deg,rgba(17,27,21,.96),rgba(26,45,35,.84) 49%,rgba(20,31,25,.18))}.hero-content{max-width:54%;position:absolute;z-index:2;top:50%;left:clamp(24px,3vw,46px);display:flex;align-items:flex-start;flex-direction:column;transform:translateY(-50%)}.hero-content small{margin-bottom:15px;color:#c8f36c!important;font-size:11px!important;font-weight:700!important;letter-spacing:.14em}.hero-content strong{color:#fff;font-size:clamp(25px,2.35vw,39px);font-weight:700;line-height:1.25;letter-spacing:-.04em}.hero-action{min-height:44px;display:inline-flex;align-items:center;gap:10px;margin-top:28px;border-radius:6px;padding:0 18px;background:#b9e858;color:#17210f;font-size:13px;font-weight:700}.hero-action.light{background:#fff;color:#243029}.hero-window{width:48%;overflow:hidden;position:absolute;z-index:2;right:-4%;bottom:8%;border:5px solid rgba(255,255,255,.82);border-radius:6px;background:#fff;box-shadow:0 20px 40px rgba(0,0,0,.28);transform:rotate(2deg)}.hero-window img{width:100%;aspect-ratio:16/10;display:block;object-fit:cover}.window-bar{height:20px;display:flex;align-items:center;gap:4px;padding:0 7px;background:#f4f5f4}.window-bar i{width:5px;height:5px;border-radius:50%;background:#cbd0cc}.tool-section{margin-top:34px}.section-title{display:flex;align-items:flex-end;justify-content:space-between;gap:24px;margin-bottom:14px}.section-title span{color:#2f63cf;font-size:10px;font-weight:800;letter-spacing:.14em}.section-title h2{margin:4px 0 0!important;font-size:23px!important}.section-title p{margin:0 0 2px}.feature-grid{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:10px}.feature-card{min-width:0;height:168px;overflow:hidden;display:flex;justify-content:space-between;gap:10px;position:relative;border:1px solid #eaeeeb;border-radius:8px;padding:15px;background:#fff;color:#17211c;text-align:left;box-shadow:0 1px 2px rgba(16,24,40,.025);transition:border-color .2s,box-shadow .2s,transform .2s}.feature-card:first-child{grid-column:span 1}.feature-card:hover{border-color:#ccd6cf;box-shadow:0 12px 26px rgba(26,42,33,.08);transform:translateY(-2px)}.feature-copy{min-width:105px;flex:1;display:flex;align-items:flex-start;flex-direction:column;position:relative;z-index:2}.tool-icon{width:32px;height:32px;display:grid;flex:0 0 32px;place-items:center;border-radius:7px;background:#f0f5ff;color:#2f63cf;font-size:16px}.feature-copy strong{margin-top:11px;font-size:15px}.feature-copy small{max-width:160px;margin-top:3px;color:#7e8982!important;font-size:10px!important;line-height:1.45}.card-link{display:flex;align-items:center;gap:4px;margin-top:auto;color:#3e6ecf;font-size:10px;font-weight:700}.feature-card>img{width:43%;max-width:150px;align-self:stretch;border-radius:6px;object-fit:cover}.compact-section{margin-top:30px}.compact-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px}.compact-card{min-width:0;min-height:92px;display:flex;align-items:center;gap:14px;border:1px solid #eaeeeb;border-radius:8px;padding:16px 18px;background:#fff;color:#17211c;text-align:left;transition:border-color .2s,box-shadow .2s}.compact-card:hover{border-color:#cdd8d1;box-shadow:0 9px 24px rgba(26,42,33,.07)}.compact-card>span:nth-child(2){min-width:0;display:flex;flex-direction:column;gap:4px}.compact-card strong{font-size:14px}.compact-card small{overflow:hidden;color:#8a948e!important;font-size:11px!important;text-overflow:ellipsis;white-space:nowrap}.compact-arrow{margin-left:auto;color:#a5aea8}@media(max-width:1380px){.feature-grid{grid-template-columns:repeat(3,minmax(0,1fr))}}@media(max-width:1180px){.home-hero{grid-template-columns:1fr}.hero-card{height:340px}.feature-grid{grid-template-columns:repeat(2,minmax(0,1fr))}}@media(max-width:900px){.compact-grid{grid-template-columns:repeat(2,minmax(0,1fr))}}@media(max-width:767px){.home-dashboard{width:calc(100% - 20px);padding:14px 0 40px}.home-hero{gap:10px}.hero-card{height:310px;border-radius:8px}.hero-content{max-width:72%;left:22px}.hero-content strong{font-size:25px}.hero-window{width:48%;opacity:.75}.section-title{align-items:flex-start;flex-direction:column;gap:5px}.feature-grid,.compact-grid{grid-template-columns:1fr}.feature-card{height:158px;padding:14px}.tool-section{margin-top:28px}}@media(prefers-reduced-motion:reduce){.hero-card>img,.feature-card,.compact-card,.hero-fade-enter-active,.hero-fade-leave-active{transition:none}}
.hero-card > img {
  position: absolute;
  inset: 0;
  transition: opacity 1.1s ease, transform 1.1s cubic-bezier(.22, .7, .25, 1);
}
.hero-card:hover > img {
  transform: scale(1.02);
}
.hero-fade-enter-active,
.hero-fade-leave-active {
  transition: opacity 1.1s ease, transform 1.1s cubic-bezier(.22, .7, .25, 1);
}
.hero-fade-enter {
  opacity: 0;
  transform: scale(1.025);
}
.hero-fade-leave-to {
  opacity: 0;
  transform: scale(.99);
}
.hero-card {
  height: clamp(260px, 24vw, 350px);
}
.section-title > p {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 3px;
  border: 1px solid #e3e9e5;
  border-radius: 999px;
  padding: 6px 10px;
  background: rgba(255, 255, 255, .72);
  color: #7f8a83 !important;
  font-size: 10px !important;
  line-height: 1.35 !important;
  box-shadow: 0 1px 2px rgba(22, 36, 28, .025);
}
.section-title > p::before {
  width: 5px;
  height: 5px;
  flex: 0 0 5px;
  border-radius: 50%;
  background: #86a3df;
  box-shadow: 0 0 0 3px #edf3ff;
  content: "";
}
/* 首页轻量整理：减少装饰噪音，强化主次层级 */
.home-dashboard {
  padding-top: 18px;
}
.home-hero {
  gap: 10px;
}
.hero-card {
  height: clamp(220px, 19vw, 285px);
  box-shadow: 0 4px 14px rgba(25, 36, 30, .05);
}
.hero-content {
  max-width: 58%;
  left: clamp(22px, 2.2vw, 32px);
}
.hero-content small {
  margin-bottom: 7px;
  font-size: 9px !important;
}
.hero-content strong {
  font-size: clamp(21px, 1.75vw, 28px);
  line-height: 1.25;
}
.hero-action {
  min-height: 36px;
  margin-top: 15px;
  padding: 0 13px;
  font-size: 11px;
}
.tool-section {
  margin-top: 28px;
}
.section-title {
  align-items: center;
  margin-bottom: 12px;
}
.section-title h2 {
  font-size: 21px !important;
}
.section-title > p {
  border-color: transparent;
  padding: 4px 8px;
  background: #f2f5f3;
  box-shadow: none;
}
.feature-grid {
  gap: 9px;
}
.feature-card {
  height: 150px;
  padding: 14px;
  box-shadow: none;
}
.feature-card:hover {
  box-shadow: 0 8px 20px rgba(26, 42, 33, .065);
}
.feature-copy {
  min-width: 96px;
}
.tool-icon {
  width: 29px;
  height: 29px;
  flex-basis: 29px;
  font-size: 15px;
}
.feature-copy strong {
  margin-top: 10px;
  font-size: 14px;
}
.feature-copy small {
  display: -webkit-box;
  overflow: hidden;
  margin-top: 3px;
  font-size: 10px !important;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.card-link {
  display: none;
}
.feature-card > img {
  width: 42%;
}
.compact-section {
  margin-top: 26px;
}
.compact-grid {
  gap: 9px;
}
.compact-card {
  min-height: 78px;
  padding: 12px 15px;
  box-shadow: none;
}
.compact-card:hover {
  box-shadow: 0 6px 16px rgba(26, 42, 33, .055);
}
@media (prefers-reduced-motion: reduce) {
  .hero-card > img,
  .hero-fade-enter-active,
  .hero-fade-leave-active {
    transition: none;
  }
}
</style>
